import React, { useEffect, useState } from 'react';
import * as Tools from '../../helpers/Tools';
import { Notifier } from "../ecosystem/";

const LoginNotice = ({
    isMobile,
    loginNotice
}) => {

    return (typeof loginNotice !== 'undefined' && loginNotice && 
        <Notifier
            variant="banner"
            icon={!isMobile ? "exclamation" : ''}
            colorStyle="error"
        >
            <div className={`login-notice-message ${isMobile ? "text-center" : "text-left"}`}>
                <div
                    dangerouslySetInnerHTML={{
                        __html: Tools.linkPhoneNumber(loginNotice),
                    }}
                />
            </div>
        </Notifier>
    );
};

export default LoginNotice;